import React from "react";

function SvgIcMapPoi052(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M27 9a1 1 0 01.993.883L28 10v12a1 1 0 01-.883.993L27 23h-7.541A4 4 0 0116 25c-1.4 0-2.63-.724-3.345-1.815L12.541 23H5a1 1 0 01-.993-.883L4 22V10a1 1 0 011.993-.117L6 10v11h8c0 1.102.898 2 2 2a2.003 2.003 0 001.995-1.851L18 21h8V10a1 1 0 011-1zM9 6h4a2 2 0 011.995 1.85L15 8v11.917c-.564-.506-1.196-.863-2-.917-.078-.008-4 0-4 0a.434.434 0 01-.086-.009.996.996 0 01-.894-.8l-.014-.061L8 18.07V7c0-.025.003-.052.008-.079a.994.994 0 01.913-.913l.04-.006L9 6h4zm14 0c.025 0 .052.003.079.008a.994.994 0 01.913.913A.441.441 0 0124 7v11.07c0 .039-.008.08-.02.121a.997.997 0 01-.894.8A.441.441 0 0123 19s-3.922-.008-4 0c-.804.054-1.436.411-2 .917V8a2 2 0 012-2h4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi052;
